import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { SecurityType } from './constants/security-type.enum';
import { AuthService } from './data/auth.service';

@Injectable({
    providedIn: 'root'
})
export class SchoolGuard {

    constructor(private authService: AuthService, private router: Router) { }

    canActivate = () => true;

    canLoad = () => this.authService.getAuthInfo().pipe(
        map(auth => {
            if (auth.userType === SecurityType.CampusLogic || auth.userType === SecurityType.Employee)
                return true;

            this.router.navigate(['/student']);
            return false;
        }),
    )

}
